import { render, staticRenderFns } from "./ReadLink.vue?vue&type=template&id=f67ec65c&"
import script from "./ReadLink.vue?vue&type=script&lang=ts&"
export * from "./ReadLink.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports